import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { cicToType } from "@/helpers/Helpers";
import { getWaveRoute } from "@/helpers/navigation.helpers";
import UserCICAndLevel, { UserCICAndLevelSize } from "@/components/user/utils/UserCICAndLevel";
import WinnerDropBadge from "../winner/WinnerDropBadge";
import WaveDropTime from "../time/WaveDropTime";
interface ParticipationDropHeaderProps {
  readonly drop: ExtendedDrop;
  readonly showWaveInfo: boolean;
}
export default function ParticipationDropHeader(t0) {
  const $ = _c(29);
  const {
    drop,
    showWaveInfo
  } = t0;
  let t1;
  if ($[0] !== drop.author.cic) {
    t1 = cicToType(drop.author.cic);
    $[0] = drop.author.cic;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const cicType = t1;
  let t2;
  if ($[2] !== cicType || $[3] !== drop.author.level) {
    t2 = <UserCICAndLevel level={drop.author.level} cicType={cicType} size={UserCICAndLevelSize.SMALL} />;
    $[2] = cicType;
    $[3] = drop.author.level;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = `/${drop.author.handle}`;
  let t4;
  if ($[5] !== drop.author.handle || $[6] !== t3) {
    t4 = <p className="tw-text-md tw-mb-0 tw-leading-none tw-font-semibold"><Link onClick={_temp} href={t3} className="tw-no-underline tw-text-iron-200 hover:tw-text-iron-500 tw-transition tw-duration-300 tw-ease-out">{drop.author.handle}</Link></p>;
    $[5] = drop.author.handle;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = <div className="tw-flex tw-items-center tw-gap-x-2">{t2}{t4}</div>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="tw-size-[3px] tw-bg-iron-600 tw-rounded-full tw-flex-shrink-0" />;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== drop.created_at) {
    t7 = <WaveDropTime timestamp={drop.created_at} />;
    $[12] = drop.created_at;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t5 || $[15] !== t7) {
    t8 = <div className="tw-flex tw-items-center tw-gap-x-2">{t5}{t6}{t7}</div>;
    $[14] = t5;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== drop.rank || $[18] !== drop.winning_context?.decision_time) {
    t9 = drop.rank && <WinnerDropBadge rank={drop.rank} decisionTime={drop.winning_context?.decision_time ?? null} />;
    $[17] = drop.rank;
    $[18] = drop.winning_context?.decision_time;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t8 || $[21] !== t9) {
    t10 = <div className="tw-flex tw-items-center tw-gap-x-4 tw-w-full">{t8}{t9}</div>;
    $[20] = t8;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== drop.wave || $[24] !== showWaveInfo) {
    t11 = showWaveInfo && drop.wave && (() => {
      const waveMeta = (drop.wave as unknown as {
        chat?: {
          scope?: {
            group?: {
              is_direct_message?: boolean;
            };
          };
        };
      })?.chat;
      const isDirectMessage = waveMeta?.scope?.group?.is_direct_message ?? false;
      const waveHref = getWaveRoute({
        waveId: drop.wave.id,
        isDirectMessage,
        isApp: false
      });
      return <Link onClick={_temp2} href={waveHref} className="tw-mb-0 tw-text-[11px] tw-leading-0 tw-text-iron-500 hover:tw-text-iron-300 tw-transition tw-duration-300 tw-ease-out tw-no-underline">{drop.wave.name}</Link>;
    })();
    $[23] = drop.wave;
    $[24] = showWaveInfo;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t10 || $[27] !== t11) {
    t12 = <>{t10}{t11}</>;
    $[26] = t10;
    $[27] = t11;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  return t12;
}
function _temp2(e_0) {
  return e_0.stopPropagation();
}
function _temp(e) {
  return e.stopPropagation();
}